var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('user-subscribe-modal',{attrs:{"show":_vm.showModal,"user":_vm.user,"filter-subscription-levels":true},on:{"close":function($event){return _vm.$emit('close')},"levelsLoaded":_vm.onLevelsLoaded}})}
var staticRenderFns = []

export { render, staticRenderFns }